// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"926d8ba5","453":"011ee027","455":"f0031c8b","977":"8096bd6d"}[chunkId] + ".chunk.js";
};